<template>
    <client-page class="wrap--sub">
        <sub-visual :visual="typeName" :class="typeClass" />

        <div class="contents">
            <div class="container">
                <template v-if="isAuthorized">
                    <div class="mb-10">
                        <v-row justify="end" class="row--small">
                            <v-col cols="auto">
                                <v-select
                                    v-model="filter.isDone"
                                    :items="statuses"
                                    item-text="text"
                                    item-value="value"
                                    hide-details
                                    outlined
                                    class="max-w200"
                                    @input="
                                        page = 1;
                                        search(true);
                                    "
                                />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn v-if="isRequester" @click="goWrite" color="primary">{{ typeName }} 신청</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="board-container">
                        <div class="table-responsive">
                            <v-data-table :headers="headers" :items="items" hide-default-footer disable-sort @click:row="goItem">
                                <template v-slot:[`item.area`]="{ item }">{{ item.areaText }}</template>
                                <template v-slot:[`item.title`]="{ item }"
                                    ><div class="ellip">{{ item.title }}</div></template
                                >
                                <template v-slot:[`item.status`]="{ item }"
                                    ><span :class="getStatusClassName(item.status)"> {{ item.status }}</span></template
                                >
                                <template v-slot:[`item.duration`]="{ item }">{{ item.startsAt.toDate() }} ~ {{ item.endsAt.toDate() }}</template>
                            </v-data-table>
                        </div>
                        <div class="pagination-container">
                            <v-pagination v-model="page" :length="pageCount" :total-visible="11" @input="search()" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="card card--primary text-center">
                        <p class="text-18 text-md-16 font-weight-medium">권한이 없습니다.</p>
                    </div>
                </template>
            </div>
        </div>
    </client-page>
</template>

<script>
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "../../templates/ClientPage.vue";
import api from "@/api";
import { COUNSEL_REQUEST_TYPES } from "@/assets/data/CONSTANTS";

const statuses = [
    { text: "전체", value: null },
    { text: "진행중", value: false },
    { text: "종료", value: true },
];
export default {
    components: { ClientPage, SubVisual },
    computed: {
        type() {
            return this.$route?.params?.type;
        },
        typeClass() {
            if (this.type == "short") return "sv3";
            if (this.type == "long") return "sv4";
            return "";
        },
        typeName() {
            if (this.type == "short") return "이음자문";
            if (this.type == "long") return "멘토링";
            return "";
        },
        isAuthorized() {
            return ["organization", "counselor"].some((scope) => this.$store.state.payload.scope?.includes(scope));
        },
        isRequester() {
            return this.$store.state.payload.scope?.includes("organization");
        },
        headers() {
            const common = [
                { text: "번호", value: "index", align: "center", width: "6%" },
                { text: "분야", value: "area", align: "center", width: "20%" },
                { text: "제목", value: "title", align: "center", width: "30%" },
                { text: "기간", value: "duration", align: "center", width: "24%" },
                { text: "상태", value: "status", align: "center", width: "10%" },
                { text: "답변현황", value: "_responses.length", align: "center", width: "10%" },
            ];
            if (this.type == "short") return common.filter(({ value }) => value !== "duration");
            if (this.type == "long") return common;
            return [];
        },
        items() {
            const base = this.totalCount - (this.page - 1) * this.limit;
            return this.requests.map((request, i) => ({ ...request, index: base - i, areaText: request?.area ? `${request?.area?.parent?.name} / ${request?.area?.name}` : "" }));
        },
    },
    data() {
        return {
            filter: {
                isDone: this.$route.query.isDone ? JSON.parse(this.$route.query.isDone) : null,
            },
            statuses,
            requests: [],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            totalCount: 0,
            limit: 10,
        };
    },
    methods: {
        async search(routable = true) {
            if (this.type && this.isAuthorized) {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, { ...this.filter, isDone: this.filter.isDone == null ? undefined : this.filter.isDone }, { page: this.page }),
                    });
                }
                const type = this.type == "short" ? COUNSEL_REQUEST_TYPES.SHORT : COUNSEL_REQUEST_TYPES.LONG;
                const {
                    summary: { totalCount },
                    counselRequests,
                } = await api.v1.counsels.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: { ...this.filter, type },
                });
                this.totalCount = totalCount;
                this.pageCount = Math.ceil(totalCount / this.limit);
                this.requests = counselRequests;
            }
        },
        goWrite() {
            this.$router.push(`/counsel/${this.type}/write`);
        },
        goItem({ _id }) {
            this.$router.push(`/counsel/${this.type}/${_id}`);
        },
        getStatusClassName(status) {
            switch (status) {
                case "대기중":
                    return "color-gray-2";
                case "진행중":
                    return "color-primary";
                case "종료":
                    return "color-gray-7e";
                default:
                    return "";
            }
        },
    },
    mounted() {
        this.search(false);
    },
    watch: {
        type() {
            this.search(false);
        },
    },
};
</script>

<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
.v-data-table {
    tr {
        td {
            cursor: pointer !important;
        }
    }
}
@media (max-width: 576px) {
    .v-data-table {
        table {
            table-layout: auto !important;
        }
        tr {
            th,
            td {
                height: auto !important;
            }
            td {
                border-bottom: 0 !important;
            }
        }
        .v-data-table-header-mobile {
            display: none;
        }
        .v-data-table__mobile-table-row {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            border-bottom: 1px solid #bbb !important;
        }
        .v-data-table__mobile-row {
            width: 50%;
            min-height: 32px;
            padding: 2px 10px !important;
            border-bottom: 1px solid #f1f1f1 !important;
        }
        .v-data-table__mobile-row:nth-child(3),
        .v-data-table__mobile-row:nth-child(4) {
            width: 100%;
        }
        .v-data-table__mobile-row:nth-child(5),
        .v-data-table__mobile-row:nth-child(6) {
            border-bottom: none;
        }
        .v-data-table__mobile-row__cell {
            word-break: break-all;
            padding-left: 10px;
        }
    }
}
</style>
